<template>
	<div class="date-range" v-bind:style="{ width: width }">
		<template v-if="row.event.length > 1">
			<div class="range" v-bind:style="{
				marginLeft: leftOffset(startTime),
				width: relativeWidth(startTime, endTime)
			}">
				<span class="start date">
					{{ formatDate(startTime) }}
				</span>
				<span class="end date">
					{{ formatDate(endTime) }}
				</span>
			</div>
		</template>
		<template v-else>
			<div class="only">
				<span class="date" v-bind:style="{ 'margin-left': centerOffset(startTime) }">
					{{ formatDate(startTime) }}
				</span>
			</div>
		</template>
	</div>
</template>

<script>
import Column from '.'

export default {
	name: 'event-date-range-column',
	extends: Column,

	props: {
		events: {
			type: Array
		},
		width: {
			type: Number,
			default: 300
		},
		minWidth: {
			type: Number,
			default: 60
		},
		timeKey: {
			type: String,
			default: 'time'
		}
	},

	methods: {
		leftOffset(time) {
			return this.width * (time - this.firstEventTime) / this.range
		},
		centerOffset(time) {
			if (this.range == 0) return 0
			return this.width * ((time - this.firstEventTime) / this.range) - this.width / 2
		},
		relativeWidth(start, end) {
			if (this.range == 0) return 0
			return Math.max(this.minWidth, this.width * (end - start) / this.range)
		}
	},

	computed: {
		sortedEvents() {
			if (this.events)
				return this.events.slice().sort((a, b) => (a[this.timeKey] - b[this.timeKey]))
			return []
		},
		firstEventTime() {
			if (this.sortedEvents.length > 0)
				return this.sortedEvents[0][this.timeKey]

		},
		lastEventTime() {
			if (this.sortedEvents.length > 0)
				return this.sortedEvents[this.sortedEvents.length - 1][this.timeKey]
		},
		range() {
			return this.lastEventTime - this.firstEventTime
		},
		valid() {
			return Array.isArray(this.row.event) && this.row.event.length > 0
		},
		startTime() {
			return this.firstEvent[this.timeKey]
		},
		endTime() {
			return this.lastEvent[this.timeKey]
		},
		firstEvent() {
			return this.row.event[0]
		},
		lastEvent() {
			return this.row.event[this.row.event.length - 1]
		},
		multipleEvents() {
			return this.row.event.length > 1
		}
	}
}
</script>

<style lang="scss" scoped>
.date-range {
	position: relative;
	height: 32px;

	.range {
		position: absolute;
		width: 200px;
	}
	.date {
		position: relative;
		bottom: 3px;
		font-weight: 500;
		font-size: 13px;
		width: 60px;
		text-align: center;
	}
	.date::before {
		content: ' ';
		position: absolute;
		width: 8px;
		height: 8px;
		border-radius: 4px;
		bottom: -4px;
		left: 25px;
		background: #cfcfcf;
	}

	.start {
		left: 15px;
		float: left;
	}
	.end {
		right: 15px;
		float: right;
	}
	> .only {
		position: absolute;
		left: 50%;
		margin-left: -30px;
		width: 60px;
		text-align: center;
		height: 20px;
	}
}
</style>
